<template>
  <div class="apply-wrapper">
    <a-row class="header-wrapper" type="flex" justify="center" align="middle">
      <a-col :span="20" class="header-content">
        <div class="flex-a-c">
          <img
            :src="Logo"
            alt="logo"
            width="54"
            height="54"
            style="margin-right: 20px"
          />
          <div class="title flex-a-c">{{ title }}</div>
        </div>
        <div class="user-info flex-a-c">
          <a-dropdown>
            <div class="pointer header-menu flex-a-c">
              <div>
                <a-avatar :src="headImg" />
              </div>
              <div class="name ellipsis">{{ user.name ? user.name : "" }}</div>
            </div>

            <a-menu slot="overlay" @click="handleClick">
              <a-menu-item key="userInfo"> 个人中心 </a-menu-item>
              <a-menu-divider />
              <a-menu-item key="logout"> 退出登录 </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-col>
    </a-row>
    <a-row class="body-wrapper" type="flex" justify="center" align="middle">
      <a-col :span="20" class="body-content">
        <div class="train-wrapper">
          <div class="train-title">申请培训</div>
          <div class="status-hint status-warning" v-if="usrtStatus === 1">
            <a-icon type="exclamation-circle" style="color: #ffbf00" />
            <!-- 审核中：我们将在五个工作日内完成审核，请耐心等待 -->
            即将开放，敬请期待
          </div>
          <div class="status-hint status-success" v-if="usrtStatus === 3">
            <a-icon type="check-circle" style="color: #52c41a" />
            恭喜！审核通过
          </div>
          <div class="status-hint status-error" v-if="usrtStatus === 2">
            <a-icon type="exclamation-circle" style="color: #f5222d" />
            审核未通过：{{ message }}
          </div>
          <div class="flex-center">
            <img src="@/assets/eys-bg.png" alt="" />
            <div class="train-sys">
              <img src="@/assets/logo-eye.png" width="40px" alt="" />
              <div class="train-sys-name">明眸学苑</div>
              <div class="train-sys-info">
                “明眸学院”是国家基层儿童青少年近视防控人员培训项目的线上服务平台。主要为学员提供云培训资料、培训动态、实操资讯、培训报名和考核评估、近视防控资源库等全面内容
              </div>
              <a-button
                type="primary"
                v-if="usrtStatus === 0"
                @click="goComplate"
              >
                立即申请
              </a-button>
              <a-button type="primary" v-if="usrtStatus === 1" :disabled="true">
                审核中
              </a-button>
              <a-button type="primary" v-if="usrtStatus === 3" @click="goHome">
                进入首页
              </a-button>
              <a-button
                type="primary"
                v-if="usrtStatus === 2"
                @click="goComplate"
              >
                重新提交资料
              </a-button>
            </div>
          </div>
        </div>
        <div class="train-wrapper">
          <div class="train-title">眼科学习流程</div>
          <div class="flex-center">
            <img style="height: 213px" src="@/assets/eye-step.png" alt="" />
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { setStorageItem, getStorageItem } from "@/utils/storage";
import { studentStatus } from "../../api/user";
import defaultHeadImg from "@/assets/imgs/default.png";
import EyeLogo from "@/assets/logo-eye.png";
export default {
  data() {
    return {
      Logo: null,
      title: "",
      headImg: "",
      message: "",
      user: {
        name: "",
        phone: ""
      },
      usrtStatus: -1 //0 未提交 1-待通过; 2-认证未通过; 3-已通过
    };
  },
  created() {
    this.user = getStorageItem("USER");
    this.Logo = EyeLogo;
    this.headImg = defaultHeadImg;
    this.title = "明眸学苑";
    this.getStatus();
  },
  methods: {
    ...mapActions({
      logout: "Logout"
    }),
    getStatus() {
      studentStatus().then(res => {
        if (res.code === 1) {
          this.message = res.results.rejectReason;
          this.usrtStatus = res.results.applyStatus;
          if (res.results.status === 1) {
            this.user.status = 1;
            setStorageItem("USER", this.user);
          }
          if (this.usrtStatus === 3) {
            this.$router.push("/");
          }
        }
      });
    },
    goComplate() {
      this.$router.push({
        name: "CompleteUserInfo"
      });
    },
    goHome() {
      this.$router.push("/");
    },
    handleClick({ key }) {
      switch (key) {
        case "userInfo":
          this.$router.push({
            name: "CompleteUserInfo"
          });
          break;
        case "logout":
          this._logout();
          break;
        default:
      }
    },
    _logout() {
      const that = this;
      this.$confirm({
        title: "退出",
        content: "确定退出系统吗？",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          that.logout().then(() => {
            that.$router.push({ name: "Login" });
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.apply-wrapper {
  min-width: 1174px;
  background: #f5f5fc;
  height: 100%;
  min-height: 100%;
  overflow-x: auto;
  .header-wrapper {
    background: rgba(255, 255, 255, 1);
  }
  .header-content {
    height: 80px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: @primary-color;
    }
    .name {
      max-width: 60px;
      color: rgba(0, 0, 0, 0.65);
      margin-left: 8px;
    }
    .user-info {
      height: 100%;
      .search-wrap {
        width: 206px;
      }
      .bell {
        padding: 0 8px;
        font-size: 20px;
        transition: all 0.3s;
        &:hover {
          color: @primary-color;
        }
      }
    }
  }
  .body-wrapper {
    margin-top: 24px;
  }
  .body-content {
    .train-wrapper {
      position: relative;
      margin-bottom: 23px;
      padding: 32px;
      background: rgba(255, 255, 255, 1);
      .status-hint {
        position: absolute;
        top: 25px;
        left: 50%;
        transform: translateX(-50%);

        padding: 9px 20px;
        width: 58%;
        min-width: 415px;
        border-radius: 5px;
      }
      .status-warning {
        border: 1px solid #ffe58f;
        background: #fffbe6;
      }
      .status-success {
        border: 1px solid #b7eb8f;
        background: #f6ffed;
      }
      .status-error {
        border: 1px solid #fff1f0;
        background: #ffa39e;
      }
      .train-title {
        font-size: 16px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
        margin-bottom: 18px;
      }
      .train-sys {
        width: 460px;
        padding: 40px 37px;
        text-align: center;
        background: #f7f9ff;
        img {
          margin-bottom: 10px;
        }
        .train-sys-name {
          margin-bottom: 10px;
          font-size: 18px;
          font-weight: bold;
        }
        .train-sys-info {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
